import ApiClient from "@/domain/core/utils/apiClient";
import client_core from "@/services/clients/client_core";

const client = new ApiClient(client_core)

const endpoints = {
    list: '/dashboard/v2/admin/refund-types/',
    detail: '/dashboard/v2/admin/refund-types/{id}/',
}

export default {
    async fetchList(filters, pagination, sorting) {
        let result = await client.get(endpoints.list, {
            ...filters,
            page_size: pagination.page_size ?? 20,
            page: pagination.page ?? 1,
            ordering: sorting.asc ? `-${sorting.column}` : sorting.column ?? ''
        })
        return {
            results: result.results,
            pagination: {
                num_pages: result.pagination.num_pages,
                page_size: result.pagination.page_size,
                page: result.pagination.page_number,
                total: result.pagination.total,
            }
        }
    },
    async fetchDetail(id) {
        return await client.get(endpoints.detail.replace('{id}', id))
    },
    async createRefundType(data) {
        return await client.post(endpoints.list, data)
    },
    async updateRefundType(id, data) {
        return await client.patch(endpoints.detail.replace('{id}', id), data)
    },
    async deleteRefundType(id) {
        await client.delete(endpoints.detail.replace('{id}', id))
    },
}
